import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { TELEMETRY_LOGS, logTelemetry } from '@/lib/telemetry.lib';

import type { ModalType } from '@/components/modals/asset-modal.types';

interface AssetActionModalState {
    activeModal: ModalType | null;
}

interface SetActiveModalOptions {
    logOpened?: boolean;
}

interface AssetActionModalActions {
    setActiveModal: (modal: ModalType | null, options?: SetActiveModalOptions) => void;
}

const storeName = 'asset-action-modal-store';

export const useAssetActionModalStore = create<AssetActionModalState & AssetActionModalActions>()(
    devtools(
        (set) => ({
            activeModal: null,
            setActiveModal: (modal, options) => {
                if (modal && options?.logOpened !== false) {
                    logTelemetry('info', TELEMETRY_LOGS.ModalOpened, {
                        modal: {
                            name: modal,
                        },
                    });
                }

                set({ activeModal: modal });
            },
        }),
        {
            name: storeName,
        }
    )
);
